import { payrollServiceApi } from "../../app/payrollServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetDownloadPayrollPayReportParams,
  GetEmployeePayReportDetailsParamsType,
  GetEmployeePayReportDetailsResponseType,
  GetSalaryReportParamsType,
  GetSalaryReportResponseType,
  GetSalarySummaryParamsType,
  GetSalarySummaryResponseType,
  GetTaxReportResponseListType,
  GetTaxReportResponseParamsType,
  GetTaxReportResponseType,
} from "../../types/payroll";

export const payrollApi = payrollServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getSalarySummary: builder.query<
      GetSalarySummaryResponseType,
      GetQueryArgsType<GetSalarySummaryParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSalarySummary,
        ...queryArgs,
      }),
      providesTags: ["GetSalarySummary"],
    }),
    generateSalary: builder.mutation({
      query: (data) => ({
        url: API_URL.generateSalary,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalarySummary", "GetSalaryReport"];
        return [];
      },
    }),
    getSalaryReport: builder.query<
      GetSalaryReportResponseType,
      GetQueryArgsType<GetSalaryReportParamsType>
    >({
      query: ({ ...args }) => {
        return {
          url: API_URL.getSalaryReport,
          ...args,
        };
      },
      providesTags: ["GetSalaryReport"],
    }),
    getEmployeePayReportDetails: builder.query<
      GetEmployeePayReportDetailsResponseType,
      GetQueryArgsType<GetEmployeePayReportDetailsParamsType>
    >({
      query: ({ params, ...args }) => {
        const { id, ...rest } = params || {};
        return {
          url: `${API_URL.getEmployeePayReportDetails}/${id}`,
          ...args,
          params: { ...rest },
        };
      },
      // keepUnusedDataFor: 0,
      // async onQueryStarted(args, { queryFulfilled, dispatch }) {
      //   try {
      //     await queryFulfilled;
      //   } catch (error) {
      //     dispatch(payrollServiceApi.util.resetApiState());
      //   }
      // },
    }),

    downloadPayrollPayReport: builder.query<
      void,
      GetQueryArgsType<GetDownloadPayrollPayReportParams>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.downloadPayrollPayReport}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
    paySlipDisbursement: builder.mutation({
      query: (data) => ({
        url: API_URL.paySlipDisbursement,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalaryReport"];

        return [];
      },
    }),
    reGenerateSalary: builder.mutation({
      query: (data) => ({
        url: API_URL.reGenerateSalary,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalaryReport"];

        return [];
      },
    }),
    reGenerateSalaryNew: builder.mutation({
      query: (data) => ({
        url: API_URL.reGenerateSalary,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalaryReport"];

        return [];
      },
    }),

    taxableReportList: builder.query<
      GetTaxReportResponseType,
      GetQueryArgsType<GetTaxReportResponseParamsType>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.downloadGrossSalary}`,
        ...queryArgs,
      }),
    }),
    taxReportList: builder.query<
      GetTaxReportResponseListType,
      GetQueryArgsType<GetTaxReportResponseParamsType>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.taxReportList}`,
        ...queryArgs,
      }),
    }),

    downloadTaxReportSingle: builder.query({
      query: (params) => {
        return {
          url: `${API_URL.downloadTaxReportSingle}`,
          params,
          responseHandler: async (response: any) => {
            const blob = await response.blob(); // Convert response to blob
            return window.URL.createObjectURL(blob); // Create object URL
          },
          cache: "no-cache",
        };
      },
    }),
    deletePayslip: builder.mutation({
      query: (data) => ({
        url: API_URL.deletePayslip,
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalarySummary", "GetSalaryReport"];

        return [];
      },
    }),
    sendSalaryReport: builder.mutation({
      query: (params) => ({
        url: API_URL.sendSalaryReport,
        method: "PATCH",
        params,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetSalarySummary", "GetSalaryReport"];

        return [];
      },
    }),
  }),
});

export const {
  useGetSalarySummaryQuery,
  useGenerateSalaryMutation,
  useGetSalaryReportQuery,
  useGetEmployeePayReportDetailsQuery,
  useLazyDownloadPayrollPayReportQuery,
  useDownloadPayrollPayReportQuery,
  usePaySlipDisbursementMutation,
  useReGenerateSalaryMutation,
  useReGenerateSalaryNewMutation,
  useTaxableReportListQuery,
  useTaxReportListQuery,
  useLazyDownloadTaxReportSingleQuery,
  useDeletePayslipMutation,
  useSendSalaryReportMutation,
} = payrollApi;
